'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getImage = function getImage(image) {
  if (image) {
    return _react2.default.createElement('img', {
      src: image.url,
      title: image.title,
      alt: image.alt
    });
  }

  return null;
};

exports.default = getImage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Page/utils/getImage.js
// module id = 433
// module chunks = 0